import { render, staticRenderFns } from "./stallInfo.vue?vue&type=template&id=7de3b872&scoped=true"
import script from "./stallInfo.vue?vue&type=script&lang=js"
export * from "./stallInfo.vue?vue&type=script&lang=js"
import style0 from "./stallInfo.vue?vue&type=style&index=0&id=7de3b872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3b872",
  null
  
)

export default component.exports